// --------------------------------------------------------------
// Created On: 2021-06-03
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import TitleBar from "../TitleBar/TitleBar";
import styles from "./Card.module.scss";

// Simple card with title.
export default function Card(props: Props): Component {
  return (
    <div className={`${styles.body} shadow-sm ${props.fullHeight ? "h-100" : ""} ${props.fullWidth ? "w-100" : ""}`}>
      <TitleBar title={props.title} />
      {props.children}
    </div>
  );
}

interface Props {
  title: string;
  fullHeight?: boolean;
  fullWidth?: boolean;
  children: null | boolean | Component | Component[];
}
